import { useLocation } from 'react-router-dom';

import checkPublicRoute from 'Helper/checkPublicRoute';
import useGetHelpRequestStatus from 'Domain/host-help-partner/useGetHelpRequestStatus';

const useIsHelpHostVisible = () => {
  const { pathname } = useLocation();
  const isPublic = checkPublicRoute(pathname);

  const { data, isPending } = useGetHelpRequestStatus({ isPublic });

  return (
    !isPending &&
    (data?.mappedStatus === 'ASSIGNED' || data?.mappedStatus === 'SEARCHING' || data?.status === 'NO_ACTIVE_OPERATORS')
  );
};

export default useIsHelpHostVisible;
